import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyA79fLaOI7v-AlV47k2Dj7w8oNr21_taDM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "vsks-orv.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "vsks-orv",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "vsks-orv.firebasestorage.app",
  messagingSenderId: "107337558328",
  appId: "1:107337558328:web:46efaabacb3e94613639cd"
}

// Защищённая инициализация
let app: firebase.app.App | undefined
let auth: firebase.auth.Auth | undefined
let db: firebase.firestore.Firestore | undefined
let storage: firebase.storage.Storage | undefined

try {
  if (!firebase.apps.length) {
    app = firebase.initializeApp(firebaseConfig)
    auth = firebase.auth()
    db = firebase.firestore()
    storage = firebase.storage()

    // === ВАЖНОЕ ИСПРАВЛЕНИЕ: Включаем long polling ===
    // Это решает проблемы с ERR_CONNECTION_RESET / ERR_CONNECTION_CLOSED
    if (db) {
      db.settings({
        experimentalForceLongPolling: true,
        // experimentalAutoDetectLongPolling: true, // можно включить вместо force, если нужно
      })
    }

    if (import.meta.env.DEV) {
      console.log("🔥 Firebase успешно инициализирован (dev) с long polling")
    }
  }
} catch (error) {
  console.error("Ошибка инициализации Firebase:", error)
}

export { auth, db, storage }